import type { ManagementModel } from "../../hooks/teamTypes";
import { TeamManagementPanel } from "../management/TeamManagementPanel";

export function ManagementPanelAdapter({
  management,
}: {
  management: ManagementModel;
}) {
  return (
    <TeamManagementPanel
      googleEmail={management.googleEmail}
      linkBusy={management.linkBusy}
      claimedPlayerId={management.claimedPlayerId}
      hasActiveGame={management.hasActiveGame}
      seasons={management.seasons}
      activeSeasonId={management.activeSeasonId}
      serverBusy={management.serverBusy}
      actionStatus={management.actionStatus}
      players={management.players}
      confirmUnclaim={management.confirmUnclaim}
      unclaimBusy={management.unclaimBusy}
      teamName={management.teamName}
      teamNameRevision={management.teamNameRevision}
      newPlayerName={management.newPlayerName}
      confirmation={management.confirmation}
      invite={management.invite}
      inviteUrl={management.inviteUrl}
      inviteCopied={management.inviteCopied}
      presence={management.presence}
      currentUserId={management.currentUserId}
      activityLoading={management.activityLoading}
      activity={management.activity}
      onLinkAccount={management.linkAccount}
      onRequestUnclaim={() => management.setConfirmUnclaim(true)}
      onUnclaim={management.unclaimPlayer}
      onCancelUnclaim={() => management.setConfirmUnclaim(false)}
      onSetTeamName={management.setTeamName}
      onNewPlayerNameChange={management.setNewPlayerName}
      onAddPlayer={management.addPlayer}
      onConfirm={management.setConfirmation}
      onDiscardGame={management.discardGame}
      onStartSeason={management.startSeason}
      onCloseSeason={management.closeSeason}
      onReopenSeason={management.reopenSeason}
      onCopyInvite={management.copyInviteLink}
      onRotateInvite={management.rotateInvite}
      onRevokeInvite={management.revokeInvite}
    />
  );
}
